import {createContext} from "react";


export const SortingContext = createContext({
    inSorting: false,
    isScanned: false,
    massTransfer: false,
    massTransferToStack: false,
    selectedContainer: {},
    selectedContainerIndex: null,
    currentMember: {},
    currentInventory: {},
    setInSorting: () => {},
    handleStartSorting: () => {},
    handleStopSorting: () => {},
    handleFinishSorting: () => {},
    refreshTrolley: () => {},
})